import { useMutation, useQueryClient } from '@tanstack/react-query';

import { omniCancelProvisioning } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';
import { environmentQueryKeys } from '@/react/portainer/environments/queries/query-keys';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { queryKeys } from './query-keys';

interface CancelProvisioningPayload {
  credentialId: number;
  environmentId: EnvironmentId;
  deleteCluster: boolean;
}

export function useCancelOmniProvisioning() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      credentialId,
      environmentId,
      deleteCluster,
    }: CancelProvisioningPayload) =>
      omniCancelProvisioning({
        path: { credentialID: credentialId },
        body: { endpointId: environmentId, deleteCluster },
      }),
    ...withInvalidate(queryClient, [
      queryKeys.clusters(),
      environmentQueryKeys.base(),
    ]),
    ...withError('Unable to cancel the provisioning'),
  });
}
